import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {CouponLandingPageService_GetStreamLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coupons/v1/landingpage/service.grpc.lazy';
import {useParams, useSrtParam} from '@aboutyou/router';
import {
  useBasketTokenAwaitedFullSession,
  useNavigationBackOptimizedBasketToken,
} from '@aboutyou/user';
import {useActivateSortingAbTest} from '../../../client-services/SortingAbTestFramework/useActivateSortingAbTest';
import {useAnyFilterFlyoutOpened} from '../../../features/Filters/shared/useAnyFilterFlyoutOpened';
import {
  getPagination,
  labelToSortingOption,
} from '../../../features/ProductStream/helpers';
import {
  useAppliedLiveAtFilter,
  useAppliedPotentialFilters,
  useKeepPreviousData,
  useResetOnFetchEnd,
  useSorting,
} from '../../../features/ProductStream/utils';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useFirstProductIds} from '../../../features/firstProductId/useFirstProductIds';
import {useProtoProductImageType} from '../../../shared-deprecated/useProductImageType';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {useCategoryIdentifier} from '../hooks/useCategoryIdentifier';

export const useCouponLandingPageStream = (page: number) => {
  const appliedFilters = useAppliedPotentialFilters();
  const liveAtFilter = useAppliedLiveAtFilter();
  const {sorting} = useSorting();
  const firstProductIds = useFirstProductIds();

  const isFilterFlyoutOpen = useAnyFilterFlyoutOpened();
  const {keepPreviousData, resetOnFetchEnd} = useKeepPreviousData();
  const {basketToken} = useNavigationBackOptimizedBasketToken({
    uniqueKey: 'clp_stream',
  });
  const {session, refetchesDisabled} = useBasketTokenAwaitedFullSession();
  const {promotionId} = useParams();
  const categoryIdentifier = useCategoryIdentifier();
  const sortingChannel = useSrtParam();
  const preferredImage = useProtoProductImageType();

  const activateSortingAbTest = useActivateSortingAbTest();

  const request = useGrpcRequest(
    CouponLandingPageService_GetStreamLazy,
    {
      category: categoryIdentifier,
      pagination: getPagination(page),
      appliedFilters: {
        filters: appliedFilters,
        liveAt: liveAtFilter
          ? {
              minDate: liveAtFilter,
            }
          : undefined,
      },
      session: session!,
      sortOptions: labelToSortingOption(sorting),
      firstProductIds,
      // The below values are unintended but are provided as defaults to make the request work. Otherwise the runtime throws an error.
      reductionsState: useReductionsStateRequestParameter(),
      basketToken,
      targetGroup: useTargetGroupIdentifier(),
      couponPromotionId: promotionId!,
      showFlyout: false,
      sortingChannel,
      preferredProductImageType: preferredImage,
    },
    {
      disabled:
        isFilterFlyoutOpen || refetchesDisabled || !promotionId || !session,
      keepPreviousData,
      onSuccess: activateSortingAbTest,
    },
  );

  useResetOnFetchEnd(request, resetOnFetchEnd);

  return request;
};
